<template>
    <div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title has-text-white">Import the following data?</p>
                <button
                    type="button"
                    class="delete"
                    @click="$emit('close')"/>
            </header>
            <section class="modal-card-body has-background-dvodark">
                <b-table
                    :data="importData"
                    :bordered="true"
                    :striped="true"
                    :narrowed="true"
                    >
                    <b-table-column field="serial" label="Serial #" v-slot="props">
                        {{ props.row.serial }}
                    </b-table-column>
                    <b-table-column field="product_code" label="Product Code" v-slot="props">
                        {{ props.row.product_code }}
                    </b-table-column>
                    <b-table-column field="serial" label="Production Date" v-slot="props">
                        {{ props.row.production_date }}
                    </b-table-column>
                    <b-table-column field="order_number" label="Order #" v-slot="props">
                        {{ props.row.order_number }}
                    </b-table-column>                       
                    <b-table-column field="po_number" label="PO #" v-slot="props">
                        {{ props.row.po_number }}
                    </b-table-column>                                                            
                </b-table>
            </section>
            <footer class="modal-card-foot">
                <div class="buttons">
                    <b-button class="is-dvogreen" @click="sendImport">Import Data</b-button>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
import { batchHandler } from '../graphql/mutations'
import { API } from 'aws-amplify';
export default {
    data(){
    return{
    }
    },
    props: ['importData'],
    methods:{
    async sendImport() {
        try {
        let myResult = await API.graphql({
            query: batchHandler,
            variables: {
                input: {
                    request_type: 'batch_import',
                    batch_array: this.importData
                }
            }
        })
        let myData = myResult.data.batchHandler
        let numberOfErrors = myResult.data.batchHandler.length
        let errorMessage = " "
        if((myData) && numberOfErrors > 0){
            errorMessage += numberOfErrors + " records failed to import"
            for(let i = 0; (i < numberOfErrors); i++ ){
                let instance = myData[i]
                errorMessage += `\n Record with Serial #: ${instance.serial}, Product Code: ${instance.product_code}, Production Date: ${instance.production_date}, Order Number: ${instance.order_number}, PO Number: ${instance.po_number}`
            }

            this.$emit('importWithErrors')
            this.$buefy.notification.open({
                message: `Imported ${this.importData.length - numberOfErrors} records. \n ${errorMessage}`,
                position: 'is-top',
                type: 'is-success',
                hasIcon: true
            })
        } else {
            this.$buefy.notification.open({
                message: `Imported ${this.importData.length} records.`,
                position: 'is-top',
                type: 'is-success',
                hasIcon: true
            }) 
        }
        this.$emit('close')
        } catch (error) {
            this.$buefy.notification.open({
                duration: 5000,
                message: `${error}`,
                position: 'is-bottom',
                type: 'is-danger',
                hasIcon: true
            })
        }
    },
    }
}
</script>